export const USER_ASSISTANCE_IP_TOKEN = '#IP';

export const USER_ASSISTANCE_TOOLTIP_KEYS = {
    available: 'app.header.options.help',
    unavailable: 'app.header.options.help.environment-unavailable',
} as const;

export const USER_ASSISTANCE_QUERY_PARAMS = {
    product: 'product',
    topic: 'topic',
    scope: 'scope',
    version: 'version',
    language: 'lang',
} as const;

export type UserAssistanceQueryParam = (typeof USER_ASSISTANCE_QUERY_PARAMS)[keyof typeof USER_ASSISTANCE_QUERY_PARAMS];
